import type { ReactNode } from "react";

/**
 * Which animation's artwork is being nudged. Each Lottie file carries its own
 * transparent padding, so the pull-back that lines the glyph up with adjacent
 * text is tuned per animation rather than shared.
 */
type InlineIconNudge = "exclamation" | "info";

// -4px / -2px / 8px in Tailwind's scale. Written out as literal classes because
// a computed name (`-ml-${n}`) generates nothing.
const nudgeClasses: Record<InlineIconNudge, string> = {
  exclamation: "mb-2 -ml-1",
  info: "mb-2 -mr-1 -ml-0.5",
};

interface AnimationsInlineIconNudgeProps {
  nudge: InlineIconNudge;
  children: ReactNode;
}

/**
 * Break glass: negative margins that pull a Lottie icon's transparent padding
 * back so the glyph sits snugly against the text beside it. Optical correction
 * for one specific piece of artwork — there is no semantic prop for it, and
 * ui-core's layout primitives deliberately offer no margin props.
 */
export function AnimationsInlineIconNudge({
  nudge,
  children,
}: AnimationsInlineIconNudgeProps) {
  return <div className={nudgeClasses[nudge]}>{children}</div>;
}
